import { Typography } from '@mui/material'

import { Box } from '../Box'
import { Kenneth } from '../Logo'

export interface ProvisioningStatusProps {
  /** What is being created, phrased for someone watching it happen. */
  message: string
}

/**
 * Fills the space a form would occupy while the record it collects is being
 * created.
 *
 * Organization creation provisions database access and storage buckets before it
 * returns, which is slow enough that a disabled button alone reads as a frozen
 * modal. Kenneth makes the wait legible as work.
 */
export const ProvisioningStatus = ({ message }: ProvisioningStatusProps) => (
  <Box variant='flexColumn' gap='md' alignItems='center' py={6} role='status' aria-live='polite'>
    <Kenneth size={96} animation='sparkles' />
    <Typography variant='body2' color='text.secondary' align='center'>
      {message}
    </Typography>
  </Box>
)
